
export const compoundTranslations = {
  en: {
    compound: {
      initialInvestment: 'Initial Investment',
      monthlyContribution: 'Periodic Contribution',
      interestRate: 'Annual Interest Rate',
      years: 'Years',
      frequency: 'Compound Frequency',
      annually: 'Annually',
      semiAnnually: 'Semi-Annually',
      quarterly: 'Quarterly',
      monthly: 'Monthly',
      daily: 'Daily',
      totalContributions: 'Total Contributions',
      interestEarned: 'Interest Earned',
      finalBalance: 'Final Balance',
      totalBalance: 'Total Balance',
      contributions: 'Total Contributions',
      year: 'Year',
      calculateToSeeCharts: 'Your investment breakdown charts will appear here after calculation',
      calculateToSeeResults: 'Fill in your details and click "Calculate" to see your results',
      // Related Content Sections
      otherCalculators: 'Other Calculators',
      relatedArticles: 'Related Articles',
      // Calculator Links
      monthlySavingsCalculator: 'Monthly Savings Calculator',
      monthlySavingsDesc: 'Calculate your monthly savings goal',
      mortgageCalculator: 'Mortgage Calculator',
      mortgageDesc: 'Calculate your mortgage payments',
      salaryCalculator: 'Salary Calculator',
      salaryDesc: 'Calculate your net salary',
      retirementCalculator: 'Retirement Calculator',
      retirementDesc: 'Plan your retirement savings',
      loanCalculator: 'Loan Calculator',
      loanDesc: 'Calculate your loan payments',
      // Article Links
      article1Title: 'How to start investing from scratch',
      article1Desc: 'Learn the basics to start your investment journey with confidence',
      article2Title: 'Understanding risk and return in investments',
      article2Desc: 'Discover how to balance risk and potential returns in your portfolio',
      article3Title: 'ETFs and Index Funds: What you need to know',
      article3Desc: 'Complete guide to understanding and investing in ETFs and index funds',
      article4Title: 'Common investing mistakes to avoid',
      article4Desc: 'Learn from the most common mistakes investors make'
    }
  },
  es: {
    compound: {
      initialInvestment: 'Inversión Inicial',
      monthlyContribution: 'Contribución Periódica',
      interestRate: 'Tasa de Interés Anual',
      years: 'Años',
      frequency: 'Frecuencia de contribuciones',
      annually: 'Anual',
      semiAnnually: 'Semestral',
      quarterly: 'Trimestral',
      monthly: 'Mensual',
      daily: 'Diaria',
      totalContributions: 'Contribuciones Totales',
      interestEarned: 'Interés Ganado',
      finalBalance: 'Balance Final',
      totalBalance: 'Balance Total',
      contributions: 'Contribuciones Totales',
      year: 'Año',
      calculateToSeeCharts: 'El desglose de su inversión aparecerá aquí después del cálculo',
      calculateToSeeResults: 'Complete sus datos y haga clic en "Calcular" para ver sus resultados',
      // Related Content Sections
      otherCalculators: 'Otras Calculadoras',
      relatedArticles: 'Artículos Relacionados',
      // Calculator Links
      monthlySavingsCalculator: 'Calculadora de Ahorro Mensual',
      monthlySavingsDesc: 'Calcula tu objetivo de ahorro mensual',
      mortgageCalculator: 'Calculadora de Hipoteca',
      mortgageDesc: 'Calcula tus pagos de hipoteca',
      salaryCalculator: 'Calculadora de Salario',
      salaryDesc: 'Calcula tu salario neto',
      retirementCalculator: 'Calculadora de Jubilación',
      retirementDesc: 'Planifica tu ahorro para la jubilación',
      loanCalculator: 'Calculadora de Préstamos',
      loanDesc: 'Calcula tus pagos de préstamo',
      // Article Links
      article1Title: 'Cómo empezar a invertir desde cero',
      article1Desc: 'Aprende los fundamentos para comenzar tu aventura de inversión con confianza',
      article2Title: 'Comprendiendo el riesgo y el retorno en las inversiones',
      article2Desc: 'Descubre cómo equilibrar el riesgo y los retornos potenciales en tu cartera',
      article3Title: 'ETFs y Fondos Indexados: Lo que necesitas saber',
      article3Desc: 'Guía completa para entender e invertir en ETFs y fondos indexados',
      article4Title: 'Errores comunes de inversión a evitar',
      article4Desc: 'Aprende de los errores más comunes que cometen los inversores'
    }
  },
  de: {
    compound: {
      initialInvestment: 'Anfangsinvestition',
      monthlyContribution: 'Regelmäßiger Beitrag',
      interestRate: 'Jährlicher Zinssatz',
      years: 'Jahre',
      frequency: 'Zinsperiode',
      annually: 'Jährlich',
      semiAnnually: 'Halbjährlich',
      quarterly: 'Vierteljährlich',
      monthly: 'Monatlich',
      daily: 'Täglich',
      totalContributions: 'Gesamtbeiträge',
      interestEarned: 'Erwirtschaftete Zinsen',
      finalBalance: 'Endsaldo',
      totalBalance: 'Gesamtsaldo',
      contributions: 'Gesamtbeiträge',
      year: 'Jahr',
      calculateToSeeCharts: 'Die Aufschlüsselung Ihrer Investition wird nach der Berechnung hier angezeigt',
      calculateToSeeResults: 'Geben Sie Ihre Daten ein und klicken Sie auf "Berechnen", um Ihre Ergebnisse zu sehen',
      // Related Content Sections
      otherCalculators: 'Andere Rechner',
      relatedArticles: 'Verwandte Artikel',
      // Calculator Links
      monthlySavingsCalculator: 'Monatlicher Sparrechner',
      monthlySavingsDesc: 'Berechnen Sie Ihr monatliches Sparziel',
      mortgageCalculator: 'Hypothekenrechner',
      mortgageDesc: 'Berechnen Sie Ihre Hypothekenzahlungen',
      salaryCalculator: 'Gehaltsrechner',
      salaryDesc: 'Berechnen Sie Ihr Nettogehalt',
      retirementCalculator: 'Rentenrechner',
      retirementDesc: 'Planen Sie Ihre Altersvorsorge',
      loanCalculator: 'Kreditrechner',
      loanDesc: 'Berechnen Sie Ihre Kreditzahlungen',
      // Article Links
      article1Title: 'Wie man von Grund auf mit dem Investieren beginnt',
      article1Desc: 'Lernen Sie die Grundlagen, um selbstbewusst in Ihre Investitionsreise zu starten',
      article2Title: 'Risiko und Rendite bei Investitionen verstehen',
      article2Desc: 'Entdecken Sie, wie Sie Risiko und potenzielle Renditen in Ihrem Portfolio ausbalancieren',
      article3Title: 'ETFs und Indexfonds: Was Sie wissen müssen',
      article3Desc: 'Vollständiger Leitfaden zum Verständnis und zur Investition in ETFs und Indexfonds',
      article4Title: 'Häufige Anlagefehler, die es zu vermeiden gilt',
      article4Desc: 'Lernen Sie aus den häufigsten Fehlern, die Anleger machen'
    }
  },
  fr: {
    compound: {
      initialInvestment: "Investissement Initial",
      monthlyContribution: "Contribution Périodique",
      interestRate: "Taux d'Intérêt Annuel",
      years: "Années",
      frequency: "Fréquence de Capitalisation",
      annually: "Annuelle",
      semiAnnually: "Semestrielle",
      quarterly: "Trimestrielle",
      monthly: "Mensuelle",
      daily: "Quotidienne",
      totalContributions: "Contributions Totales",
      interestEarned: "Intérêts Gagnés",
      finalBalance: "Solde Final",
      totalBalance: "Solde Total",
      contributions: "Contributions Totales",
      year: "Année",
      calculateToSeeCharts: "Vos graphiques de répartition d'investissement apparaîtront ici après calcul",
      calculateToSeeResults: "Remplissez vos détails et cliquez sur \"Calculer\" pour voir vos résultats",
      // Related Content Sections
      otherCalculators: 'Autres Calculatrices',
      relatedArticles: 'Articles Connexes',
      // Calculator Links
      monthlySavingsCalculator: "Calculatrice d'Épargne Mensuelle",
      monthlySavingsDesc: "Calculez votre objectif d'épargne mensuel",
      mortgageCalculator: 'Calculatrice Hypothécaire',
      mortgageDesc: 'Calculez vos paiements hypothécaires',
      salaryCalculator: 'Calculatrice de Salaire',
      salaryDesc: 'Calculez votre salaire net',
      retirementCalculator: 'Calculatrice de Retraite',
      retirementDesc: 'Planifiez votre épargne retraite',
      loanCalculator: 'Calculatrice de Prêt',
      loanDesc: 'Calculez vos paiements de prêt',
      // Article Links
      article1Title: 'Comment commencer à investir de zéro',
      article1Desc: 'Apprenez les bases pour commencer votre parcours d\'investissement en toute confiance',
      article2Title: 'Comprendre le risque et le rendement dans les investissements',
      article2Desc: 'Découvrez comment équilibrer le risque et les rendements potentiels dans votre portefeuille',
      article3Title: 'ETF et Fonds Indiciels: Ce que vous devez savoir',
      article3Desc: 'Guide complet pour comprendre et investir dans les ETF et les fonds indiciels',
      article4Title: 'Erreurs d\'investissement courantes à éviter',
      article4Desc: 'Apprenez des erreurs les plus courantes que font les investisseurs'
    }
  },
  hi: {
    compound: {
      initialInvestment: "प्रारंभिक निवेश",
      monthlyContribution: "आवधिक अंशदान",
      interestRate: "वार्षिक ब्याज दर",
      years: "वर्ष",
      frequency: "चक्रवृद्धि आवृत्ति",
      annually: "वार्षिक रूप से",
      semiAnnually: "अर्ध-वार्षिक रूप से",
      quarterly: "त्रैमासिक रूप से",
      monthly: "मासिक रूप से",
      daily: "दैनिक रूप से",
      totalContributions: "कुल अंशदान",
      interestEarned: "अर्जित ब्याज",
      finalBalance: "अंतिम शेष राशि",
      totalBalance: "कुल शेष राशि",
      contributions: "कुल अंशदान",
      year: "वर्ष",
      calculateToSeeCharts: "गणना के बाद आपके निवेश ब्रेकडाउन चार्ट यहाँ दिखाई देंगे",
      calculateToSeeResults: 'अपना विवरण भरें और अपने परिणाम देखने के लिए "गणना करें" पर क्लिक करें',
      // Related Content Sections
      otherCalculators: 'अन्य कैलकुलेटर',
      relatedArticles: 'संबंधित लेख',
      // Calculator Links
      monthlySavingsCalculator: 'मासिक बचत कैलकुलेटर',
      monthlySavingsDesc: 'अपने मासिक बचत लक्ष्य की गणना करें',
      mortgageCalculator: 'बंधक कैलकुलेटर',
      mortgageDesc: 'अपने बंधक भुगतान की गणना करें',
      salaryCalculator: 'वेतन कैलकुलेटर',
      salaryDesc: 'अपनी शुद्ध वेतन की गणना करें',
      retirementCalculator: 'सेवानिवृत्ति कैलकुलेटर',
      retirementDesc: 'अपनी सेवानिवृत्ति बचत की योजना बनाएं',
      loanCalculator: 'ऋण कैलकुलेटर',
      loanDesc: 'अपने ऋण भुगतान की गणना करें',
      // Article Links
      article1Title: 'शुरुआत से निवेश कैसे शुरू करें',
      article1Desc: 'आत्मविश्वास के साथ अपनी निवेश यात्रा शुरू करने के लिए मूल बातें सीखें',
      article2Title: 'निवेश में जोखिम और रिटर्न को समझना',
      article2Desc: 'अपने पोर्टफोलियो में जोखिम और संभावित रिटर्न को संतुलित करने का तरीका जानें',
      article3Title: 'ईटीएफ और इंडेक्स फंड: आपको क्या जानना चाहिए',
      article3Desc: 'ईटीएफ और इंडेक्स फंड को समझने और निवेश करने के लिए पूर्ण गाइड',
      article4Title: 'बचने के लिए सामान्य निवेश गलतियां',
      article4Desc: 'निवेशक जो सबसे आम गलतियां करते हैं उनसे सीखें'
    }
  }
};
